<script>
  import { showHistory } from '../versioning';
  import History from './History.svelte';
</script>

{#if $showHistory}
  <History />
{/if}
